import { avatarUrlBuilder } from "@common";
import { useSelector } from "react-redux";
import type { IRootState } from "../../redux/store";
import { useEffect, useState } from "react";
import NotifyCopyLink from "../NotifyCopyLink/NotifyCopyLink";
import DeployAvatarConfirm from "../DeployAvatarConfirm/DeployAvatarConfirm";
import { copyToClipboard, createPlayerSettings } from "../../utils/shared";
import { useNavigate } from "react-router-dom";
import routes from "../../routs";
import { trackPrompt, trackPublish, trackUserTimeInApp } from "../../utils/analyticsTracker";
import { calculateSessionDuration } from "../../utils/cookieUtils";

interface Props {
	onClose: () => void;
	setIsPublished: (value: boolean) => void;
	handleClosePreview: () => void;
}

const DeployAvatarModal: React.FC<Props> = ({ onClose, setIsPublished, handleClosePreview }) => {
	const [isDeployConfirmed, setIsDeployConfirmed] = useState(false);
	const formData = useSelector((state: IRootState) => state.avatarForm);
	const brainId = useSelector((state: IRootState) => state.avatar.brainId);
	const avatarSettings = createPlayerSettings(formData, brainId);
	const link = avatarUrlBuilder(avatarSettings);
	const navigate = useNavigate();

	const handleCopyLink = () => {
		copyToClipboard(link);
	};

	const handleClose = () => {
		onClose();
		setIsPublished(false);
	};

	useEffect(() => {
		if (!isDeployConfirmed) return;
		copyToClipboard(link);
		trackPublish();
		trackPrompt(formData.prompt);
		const userSessionTime = calculateSessionDuration();
		if (userSessionTime) {
			trackUserTimeInApp(userSessionTime);
		}
		handleClosePreview();
	}, [isDeployConfirmed]);

	if (isDeployConfirmed) {
		return <NotifyCopyLink handleCopyLink={handleCopyLink} link={link} onClose={() => navigate(routes.home)}/>;
	}

	return (
		<DeployAvatarConfirm onClose={handleClose} openCopyLink={() => setIsDeployConfirmed(true)} />
	)
};

export default DeployAvatarModal;
